import {
  CLEAN_TAX_ZONES,
  CREATE_INITIATED,
  DELETE_INITIATED,
  SET_TAX_ZONES_LIST,
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
  TAX_ZONE_CREATED,
  TAX_ZONE_DELETED,
  TAX_ZONE_UPDATED,
  UPDATE_INITIATED,
} from './actionTypes';

import {
  ITaxZonesAction,
  ITaxZonesState,
  ISetTaxZonesAction,
  IFailedSyncAction,
  ITaxZone,
  IDeleteTaxZoneAction,
  ISetTaxZoneAction,
} from './types';

const initialSync = {
  syncing: false,
  updateInitiated: false,
  createInitiated: false,
  deleteInitiated: false,
};

const resetActionsSync = {
  error: null,
  taxZoneUpdated: false,
  taxZoneCreated: false,
  taxZoneDeleted: false,
};

export const initialState = {
  taxZones: [],
  taxZonesLoaded: false,
  ...initialSync,
  ...resetActionsSync,
};

export const reducer = (
  state: ITaxZonesState = initialState,
  action: ITaxZonesAction
): ITaxZonesState => {
  switch (action.type) {
    case SYNC_INITIATED:
      return { ...state, ...resetActionsSync, syncing: true };
    case SYNC_FINISHED:
      return { ...state, ...initialSync };
    case SET_TAX_ZONES_LIST:
      return {
        ...state,
        taxZones: (action as ISetTaxZonesAction).payload,
        taxZonesLoaded: true,
      };
    case TAX_ZONE_UPDATED:
      return {
        ...state,
        taxZones: state.taxZones.map((taxZone: ITaxZone) => {
          const updatedTaxZone = (action as ISetTaxZoneAction).payload;
          return taxZone.zoneId !== updatedTaxZone.zoneId ? taxZone : updatedTaxZone;
        }),
        taxZoneUpdated: true,
      };
    case UPDATE_INITIATED:
      return {
        ...state,
        ...resetActionsSync,
        updateInitiated: true,
      };
    case TAX_ZONE_CREATED:
      return {
        ...state,
        taxZones: [...state.taxZones, (action as ISetTaxZoneAction).payload],

        taxZoneCreated: true,
      };
    case CREATE_INITIATED:
      return {
        ...state,
        ...resetActionsSync,
        createInitiated: true,
      };
    case TAX_ZONE_DELETED:
      return {
        ...state,
        taxZones: state.taxZones.filter(
          (taxZone: ITaxZone) => taxZone.zoneId !== (action as IDeleteTaxZoneAction).payload
        ),
        taxZoneDeleted: true,
      };
    case DELETE_INITIATED:
      return {
        ...state,
        ...resetActionsSync,
        deleteInitiated: true,
      };
    case CLEAN_TAX_ZONES:
      return {
        ...state,
        taxZones: [],
      };
    case SYNC_FAILED:
      return { ...state, error: (action as IFailedSyncAction).payload };
    default:
      return state;
  }
};
